/**
 * @generated SignedSource<<831a24c76cd513b18ebaee9190860c45>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type LinkPipedriveDealInput = {
  projectId?: string | null;
  dealId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type LinkPipedriveDealMutation$variables = {
  input: LinkPipedriveDealInput;
};
export type LinkPipedriveDealMutation$data = {
  readonly linkPipedriveDeal: {
    readonly project: {
      readonly pipedriveDeal: string | null;
    } | null;
  } | null;
};
export type LinkPipedriveDealMutation = {
  variables: LinkPipedriveDealMutation$variables;
  response: LinkPipedriveDealMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pipedriveDeal",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LinkPipedriveDealMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LinkPipedriveDealPayload",
        "kind": "LinkedField",
        "name": "linkPipedriveDeal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LinkPipedriveDealMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LinkPipedriveDealPayload",
        "kind": "LinkedField",
        "name": "linkPipedriveDeal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9f6cd07f365cc77e5f5af2402816eb79",
    "id": null,
    "metadata": {},
    "name": "LinkPipedriveDealMutation",
    "operationKind": "mutation",
    "text": "mutation LinkPipedriveDealMutation(\n  $input: LinkPipedriveDealInput!\n) {\n  linkPipedriveDeal(input: $input) {\n    project {\n      pipedriveDeal\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c1606868eae977de36c41cbee466438c";

export default node;
